<template>
  <div>
    <!-- <div class="course_list flex FlexWrap FlexBetween" ref="content" :class="{ expanded: isExpanded }"
      v-if="courseList.length">
      <div class="flex course_one flexcolumn FlexEvenly" v-for="(item, index) in courseList" :key="index" @mouseenter="showMoreInfo(item)" @mouseleave="hideMoreInfo(item)" :class="[selectedCourseId == item.courseInfo.courseId ? 'hover_box' : '']">
        <div class="cursor_pointer" @click.stop="goCourseDetail(item?.courseInfo, item)">
          <div class="course_one_top">
            <el-image class="course_one_img" :src="imgPath(item?.courseInfo.courseCoverImg)"></el-image>
            <div class="course_one_type">{{ item.schemeName }}</div>
          </div>
          <div class="course_one_title toverflows toverflow2">
            {{ item?.courseInfo.courseName }}
          </div>
          <div class="course_one_institution flex FlexBetween">
            <div class="course_one_institution_left flex Flexalign">
              <el-avatar :size="24" :src="item?.courseInfo.shopLogo" />
              <div class="institutionName toverflow">{{ item?.courseInfo.shopName }}</div>
            </div>
            <div class="course_num">
              {{ item.learnedInfo?.chapterNum }}课时
            </div>
          </div>
          <div class="course_rate flex FlexBetween Flexalign">
            <el-rate v-model="item.rate" disabled show-score text-color="#666666" score-template="{value}分" />
            <div class="course_online">
              {{ item?.courseInfo?.courseExtra?.userNum }}人学习
            </div>
          </div>
          <div class="course_info">
            <div class="flex FlexBetween mt-5">
              <div class="course_finish"
                v-if="item.learnedInfo?.alreadyStudyChapterNum == item.learnedInfo?.chapterNum">
                已学习完成
              </div>
              <div class="course_finish" v-else>
                已学习{{ item.learnedInfo?.alreadyStudyChapterNum }}/{{ item.learnedInfo?.chapterNum }}章节
              </div>
              <div class="text_active cursor_pointer" @click.stop="setting(item)">设置</div>
            </div>
            <el-progress :percentage="(item.learnedInfo?.alreadyStudyChapterNum / item.learnedInfo?.chapterNum)*100"
              color="rgba(0, 212, 152, 1)" :show-text="false"></el-progress>
          </div>
        </div>
      </div>
      <div v-if="courseList.length % 3 != 0" class="flex">
        <div class="empty_course_one course_one" v-for="item in 3 - (courseList.length % 3)" :key="item">
          <div class="course_one_top">
            <el-image class="course_one_img" style="border-radius: 20px" :src="imgPath('course_img.png')"></el-image>
            <div class="course_one_type">热销</div>
          </div>
        </div>
      </div>
    </div> -->
    <div v-if="courseList.length">
      <div class="course_one_new flex Flexalign mt-20" v-for="(item, index) in courseList" :key="index">
        <el-image class="course_one_new_cover" :src="item?.courseInfo.courseCoverImg"></el-image>
        <div class="course_one_new_info ml-15 flex flexcolumn FlexBetween flex-1">
          <div class="course_one_new_info_top flex Flexalign FlexBetween">
            <div class="flex Flexalign">
              <!-- <el-image class="stick_top_tag mr-10" :src="iconPath('stick_top_tag_icon.png')"></el-image> -->
              <div>{{ item?.courseInfo.courseName }}</div>
            </div>
            <div class="more_icon mar_left_30 cursor_pointer" @mouseenter="showMoreChoice(item)" @mouseleave="hideMoreChoice(item)">
              <el-icon color="rgba(102, 102, 102, 1)" :size="16">
                <More />
              </el-icon>
              <div class="more_choice pl-10" v-if="item.showMoreChoice">
                <!-- <div class="cursor_pointer">置顶</div> -->
                <div class="cursor_pointer" @click.stop="setting(item)">更换方案</div>
              </div>
            </div>
          </div>
          <div class="course_one_new_info_center flex Flexalign">
            <div>当前学习方案：{{ item.schemeName }}</div>
            <div class="split_line mx-15"></div>
            <div>共 {{ item.learnedInfo?.chapterNum }} 课时</div>
          </div>
          <div class="course_one_new_info_bottom flex Flexalign FlexBetween px-15">
            <div class="course_one_new_info_bottom_left flex Flexalign">
              {{ item.chapterName?`正在学习  ${item.chapterName}`:'暂未开始学习' }}
              <el-image class="double_right_icon ml-5" :src="iconPath('double_right_icon.png')"></el-image>
            </div>
            <div class="btn_learn cursor_pointer" @click.stop="goCourseDetail(item?.courseInfo, item)">{{item.chapterId?'继续学习':'开始学习'}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="empty_box flex flexcolumn Flexalign" v-else>
      <moe-empty url="moe_empty_bg_img.png" emptyText="暂无课程"></moe-empty>
    </div>
    <setCoursePlan ref="setCoursePlan" @getMyCourseList="getMyCourseList"></setCoursePlan>
  </div>
</template>

<script>
import setCoursePlan from '@/components/popup/setCoursePlan.vue';
export default {
  name: "GjkcH5CollectList",
  props: {
    selectedInfo: {},
  },
  components: { setCoursePlan },

  data() {
    return {
      courseList: [],
      isExpanded: false,
      showLoadMore: false,
      selectedCourseId: ''
    };
  },

  watch: {
    items: {
      immediate: true,
      handler() {
        this.$nextTick(this.checkOverflow);
      },
    },
    selectedInfo: {
      handler(value) {
        if (!value) return;
        setTimeout(() => {
          this.getMyCourseList();
        }, 500);
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    // this.checkOverflow();
  },

  methods: {
    showMoreChoice(info){
      info.showMoreChoice = true;
    },
    hideMoreChoice(info){
      info.showMoreChoice = false;
    },
    showMoreInfo(info) {
      this.selectedCourseId = info.courseInfo.courseId;
      info.showCourseMoreInfo = true;
    },
    hideMoreInfo(info) {
      this.selectedCourseId = "";
      info.showCourseMoreInfo = false;
    },
    setting(info) {
      this.$refs.setCoursePlan.setCoursePlanShow = true;
      this.$refs.setCoursePlan.courseId = info.courseInfo.courseId;
      this.$refs.setCoursePlan.getSchemeByCourseId();
      this.$refs.setCoursePlan.planValue = info.schemeId;
      this.$refs.setCoursePlan.courseInfo = info.courseInfo;
    },
    checkOverflow() {
      if (!this.$refs.content) return;
      this.showLoadMore =
        this.$refs.content.scrollHeight > this.$refs.content.clientHeight;
    },
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
    },

    // 获取我的课程列表
    getMyCourseList() {
      this.$Api.course
        .getMyCourseList(this.selectedInfo)
        .then((res) => {
          this.$emit('getListTotal', res.data.data.total);
          this.courseList = res.data.data.list;
          this.courseList.forEach((item) => {
            item.rate = this.$Tools.scoreToStar(
              item.courseInfo.courseExtra.appraiseScore
            );
            item.learnedInfo = {};
            item.showMoreChoice = false;
          });
          setTimeout(() => {
            // 没有数据不在请求接口了
            if (!res.data.data.list?.length) return
            this.getMycourseListProgress();
            this.checkOverflow();
          }, 500);
        })
        .catch(() => { });
    },
    // 详情
    goCourseDetail(info, courseInfo) {
      // 设置缓存
      this.$store.commit("learning/setCourseScheme", courseInfo.schemeId);
      setTimeout(() => {
        this.$Jump.href("/onlineLearning", { courseId: info.courseId });
      }, 500)
    },
    getMycourseListProgress() {
      let ids = [];
      this.courseList.forEach((item) => {
        ids.push(item.courseInfo.courseId);
      });
      this.$Api.learning
        .getMycourseListProgress({ courseIds: ids.join(",") })
        .then((res) => {
          this.courseList.forEach((item) => {
            let currentIndex = res.data.data.findIndex(
              (sitem) => sitem.courseId == item.courseInfo.courseId
            );
            if (currentIndex != -1) {
              item.learnedInfo = res.data.data[currentIndex];
            } else {
              item.learnedInfo = {
                courseId: item.courseInfo.courseId,
                chapterNum: "",
                previewChapterNum: "",
                videoDuration: "",
                alreadyStudyChapterNum: "0",
                waitStudyChapterNum: "0",
                watchedTotalProgress: 0,
              };
            }
          });
        })
        .catch(() => { });
    },
  },
};
</script>
<style lang="scss" scoped>
.course_list {
  width: 100%;
  // max-height: 710px;
  overflow: hidden;

  .course_one {
    // box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
    // box-shadow: 0px 0px 16px 2px rgba(0,0,0,0.1);
    border-radius: 20px;
    border: 1px solid #e3e3e3;
    padding: 11px;
    box-sizing: border-box;
    height: 340px;
    margin-top: 12px;

    .course_one_top {
      position: relative;

      .course_one_img {
        width: 235px;
        height: 148px;
        border-radius: 10px;
      }

      .course_one_type {
        position: absolute;
        right: 0;
        top: 0;
        width: 54px;
        height: 21px;
        background: linear-gradient(97deg, #00D498 0%, #00D5C2 100%);
        border-radius: 0px 10px 0px 20px;
        font-size: 14px;
        color: #ffffff;
        text-align: center;

        .delete_gray_icon {
          width: 18px;
          height: 18px;
        }
      }
    }

    .course_one_title {
      width: 235px;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      margin: 5px 0;
      height: 50px;
    }

    .course_one_institution {
      .course_one_institution_left {
        .institutionName {
          max-width: 150px;
          color: #333333;
          margin-left: 6px;
        }
      }

      .course_num {
        color: #666666;
      }
    }

    .course_rate {
      :deep(.el-rate .el-rate__icon) {
        margin-right: 0;
      }

      :deep(.el-rate) {
        height: auto;
      }

      .course_online {
        font-size: 14px;
        color: #999999;
      }
    }

    .course_info {
      .course_finish {
        font-size: 14px;
        color: #13d6aa;
        margin-bottom: 10px;
      }
    }
  }

  .hover_box {
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
    animation: moveUp 0.5s forwards;
    z-index: 9;
  }

  .empty_course_one {
    opacity: 0;
  }
}

.course_one_new {
  .course_one_new_cover {
    width: 180px;
    height: 115px;
    border-radius: 10px;
  }

  .course_one_new_info {
    height: 115px;

    .course_one_new_info_top {
      .stick_top_tag {
        width: 36px;
        height: 19px;
      }

      .more_icon {
        position: relative;

        .more_choice {
          position: absolute;
          width: 90px;
          // height: 63px;
          height: 33px;
          background: #FFFFFF;
          box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.07);
          border-radius: 6px;
          right: 0;
          top: 10px;
          font-size: 14px;
          color: #606060;
          line-height: 30px;
          box-sizing: border-box;
        }
      }
    }

    .course_one_new_info_center {
      font-size: 14px;
      color: #979797;

      .split_line {
        width: 1px;
        height: 12px;
        background: #979797;
      }
    }

    .course_one_new_info_bottom {
      height: 36px;
      background: #F6F8FC;
      border-radius: 18px;

      .course_one_new_info_bottom_left {
        font-size: 14px;
        color: #FF433D;

        .double_right_icon {
          width: 13px;
          height: 13px;
        }
      }

      .btn_learn {
        width: 76px;
        height: 30px;
        background: #1FD294;
        border-radius: 15px;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 30px;
        text-align: center;
      }
    }
  }
}

.course_list.expanded {
  max-height: none;
  overflow: visible;
  /* 展开后高度 */
}

.more_load {
  width: 200px;
  height: 35px;
  background: #f5f6f8;
  border-radius: 8px;
  line-height: 35px;
  text-align: center;
  margin: 10px auto;
}

.empty_box {
  width: 260px;
  height: 260px;
  margin: 30px auto;
  color: #666666;

  .empty_img {
    width: 200px;
    height: 200px;
  }
}
</style>
